export enum AttachmentTypeEnum {
  Frontage = 'frontage',
  Order = 'order',
  Visitation = 'visitation',
  Metas = 'metas',
  Other = 'other',
  Process = 'processo',
}
